module.exports = __webpack_public_path__ + "static/media/PRE CONSTRUCTION.d18e6372.jpg";